import { useMutation } from 'react-query';

import { putEncounterNewLocation } from 'api/InteractiveMap/putEncounterNewLocation';

const usePutEncounterNewLocation = () => {
  const { isSuccess, mutate: putEncounterNewLocationMutate, isLoading } = useMutation(putEncounterNewLocation);

  return {
    isSuccess,
    putEncounterNewLocation: putEncounterNewLocationMutate,
    isLoading,
  };
};

export default usePutEncounterNewLocation;
